import ConfigurationParametersGlobalService from '@/modules/configurationModule/detail/parameters/services/configuration-parameters-global.service'
import ConfigurationParametersLocalService from '@/modules/configurationModule/detail/parameters/services/configuration-parameters-local.service'
import { ConfigurationParameterOptionResponse } from '@/modules/configurationModule/detail/parameters/services/configuration-parameters.dto'
import { Nullable } from '@/shared/types/app.types'

export enum ConfigurationParameterTypeEnum {
    BOOLEAN = 'boolean',
    NUMBER = 'number',
    TEXT = 'string',
    DATE = 'date',
    LIST = 'configured-selection'
}

export type ConfigurationParameterService = ConfigurationParametersGlobalService | ConfigurationParametersLocalService
export type ConfigurationParameterType = Nullable<boolean | number | string | Date | ConfigurationParameterOptionResponse>

export interface ConfigurationParameter {
    id: number,
    name: string,
    options: ConfigurationParameterOptionResponse[]
    type: ConfigurationParameterTypeEnum
    value: ConfigurationParameterType
}
